import FacebookIcon from '~/assets/icons/Facebook';
import InstagramIcon from '~/assets/icons/Instagram';
import TikTokIcon from '~/assets/icons/TikTok';
import TwitterIcon from '~/assets/icons/Twitter';
import YoutubeIcon from '~/assets/icons/Youtube';

type IconGalleryProps = {
  fillColour: string;
  hrefs: string[];
  icons: Array<'facebook' | 'instagram' | 'tiktok' | 'twitter' | 'youtube'>;
  onLinkClick?: (href: string, position: number) => void;
  target?: string;
};

const socialIcons = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  tiktok: TikTokIcon,
  twitter: TwitterIcon,
  youtube: YoutubeIcon
};

const socialLabels = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  twitter: 'Twitter',
  youtube: 'Youtube'
};

export default function IconGallery({
  icons,
  hrefs,
  fillColour,
  onLinkClick,
  target = '_blank'
}: IconGalleryProps) {
  return (
    <ul className="mx-auto my-0 flex max-w-60 justify-between lg:flex-grow lg:flex-col">
      {icons.map((icon, index: number) => {
        const SocialIcon = socialIcons[icon];
        const href = hrefs[index];

        return (
          <li key={index} className="m-0 lg:mb-6">
            <a
              className="inline-block size-6"
              href={href}
              onClick={() => {
                if (href) onLinkClick?.(href, index + 1);
              }}
              target={target}
              rel="noopener noreferrer"
              title={`Sole Supplier on ${socialLabels[icon]} [New Window]`}
            >
              <SocialIcon width="24" height="24" fill={fillColour} />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
